import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { Apple, Dumbbell, Snowflake, Brain, Pill, ArrowRight, ArrowLeft } from 'lucide-react';

const pillars = [
  { icon: Apple, title: 'Nutrition', desc: 'Eat Better. Burn Fat.', color: '#65A30D', bg: 'bg-[var(--c-green-soft)]', border: 'border-[var(--c-green-soft)]' },
  { icon: Dumbbell, title: 'Movement', desc: 'Move Better. Build Strength.', color: '#00C8FF', bg: 'bg-[#00C8FF]/10', border: 'border-[#00C8FF]/30' },
  { icon: Snowflake, title: 'Recovery', desc: 'Recover Better. Recharge.', color: '#7DD3FC', bg: 'bg-[#7DD3FC]/10', border: 'border-[#7DD3FC]/30' },
  { icon: Brain, title: 'Mindset', desc: 'Think Better. Stay Consistent.', color: '#FFB800', bg: 'bg-[#FFB800]/10', border: 'border-[#FFB800]/30' },
  { icon: Pill, title: 'Supplements & Longevity', desc: 'Support Your Body. Live Longer.', color: '#FF6FA8', bg: 'bg-[#FF6FA8]/10', border: 'border-[#FF6FA8]/30' },
];

export default function Method() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex flex-col px-6 pt-12 pb-10 max-w-2xl mx-auto">
      <button data-testid="back-btn" onClick={() => nav(-1)} className="text-muted-foreground hover:text-foreground inline-flex items-center gap-2 text-sm"><ArrowLeft className="w-4 h-4" /> Back</button>
      <div className="mt-8">
        <div className="label-mini text-[#00C8FF]">The Pillar Architecture</div>
        <h1 className="font-display font-black text-4xl md:text-5xl mt-3 tracking-tight">YourReGen Protocol</h1>
        <p className="text-muted-foreground mt-3">Five interconnected pillars. Each one amplifies the others.</p>
      </div>

      {/* Pillars with connection line */}
      <div className="relative mt-8 flex-1">
        {/* vertical connection line */}
        <div className="absolute left-[31px] top-6 bottom-6 w-px bg-gradient-to-b from-[var(--c-green)] via-[#00C8FF] via-[#7DD3FC] via-[#FFB800] to-[#FF6FA8] opacity-40" />

        <div className="space-y-3">
          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, x: -16 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.1 }}
              className={`relative regen-card-elevated p-4 flex items-center gap-4 border ${p.border}`}
            >
              <div className={`relative z-10 w-14 h-14 rounded-2xl flex items-center justify-center ${p.bg} ring-4 ring-[var(--c-elev)]`}>
                <p.icon className="w-6 h-6" style={{ color: p.color }} strokeWidth={2.2} />
              </div>
              <div className="flex-1">
                <div className="font-display font-bold text-lg">{p.title}</div>
                <div className="text-sm" style={{ color: p.color }}>{p.desc}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Footer tagline */}
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8 }} className="mt-8 text-center">
        <div className="font-display font-black text-2xl tracking-tight">
          <span className="text-[#00C8FF]">One System.</span>{' '}
          <span className="text-[var(--c-green-ink)]">One Coach.</span>{' '}
          <span>One Transformation.</span>
        </div>
      </motion.div>

      <Button
        onClick={() => nav('/onboarding/receive')}
        data-testid="continue-method-btn"
        className="mt-6 h-14 w-full bg-[#00C8FF] hover:bg-[#00C8FF]/90 text-[#081726] font-semibold rounded-2xl"
      >
        Continue <ArrowRight className="ml-2 w-4 h-4" />
      </Button>
    </div>
  );
}
